import ApiService from './api.service'

class SMSCollectionError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const SMSCollectionService = {
    /**
     * Fetch current user's newsletter list and store the access token to StorageService. 
     * 
     * @returns smscollectionList
     * @throws SMSCollectionError 
    **/
    fetchAll: async function(page) {
        try {
            //ApiService.setHeaders();
            const response = await ApiService.get("/sms-collections/list?page="+page)
            
            return response.data
        } catch (error) {
            throw new SMSCollectionError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Fetch sms group's templates
     * 
     * @returns template list
     * @throws SMSCollectionError 
    **/
    fetchGroupTemplates: async function(groupId, page) {

       try {
            const response = await ApiService.get(`/sms-collections/${groupId}/templates?page=${page}`)

            return response.data

        } catch (error) {
            throw new SMSCollectionError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Create new sms collection
     * 
     * @returns response
     * @throws SMSCollectionError 
    **/
    createGroup: async function(data)
    {
        try {
            const response = await ApiService.post("/sms-collections/create", data)
            return response.data
        } catch (error) {
            throw new SMSCollectionError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Fetch sms collection group by id. 
     * 
     * @returns SMSCollection
     * @throws SMSCollectionError 
    **/
    fetchGroup: async function(id) {
        try {
            const response = await ApiService.get(`/sms-collections/${id}`)
            
            return response.data
        } catch (error) {
            throw new SMSCollectionError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Delete template group by id. 
     * 
     * @returns response
     * @throws SMSCollectionError 
    **/
    deleteGroup: async function(id) {
        try {
            const response = await ApiService.delete(`/sms-collections/${id}`)
            
            return response.data
        } catch (error) {
            throw new SMSCollectionError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Save template message 
     * 
     * @returns response
     * @throws SMSCollectionError 
    **/
    saveMessage: async function(groupId, data) {
        try {
            const response = await ApiService.post(`/sms-collections/${groupId}/templates`, data)
            
            return response.data

        } catch (error) {
            throw new SMSCollectionError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Fetch template message by id. 
     * 
     * @returns response
     * @throws SMSCollectionError 
    **/
    fetchMessage: async function(groupId, id) {
        try {
            const response = await ApiService.get(`/sms-collections/${groupId}/templates/${id}`)
            
            return response.data
        } catch (error) {
            throw new SMSCollectionError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Update template message 
     * 
     * @returns response
     * @throws SMSCollectionError 
    **/
    updateMessage: async function(groupId, id, data) {
        try {
            const response = await ApiService.put(`/sms-collections/${groupId}/templates/${id}`, data)
            
            return response.data

        } catch (error) {
            throw new SMSCollectionError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Delete message by id. 
     * 
     * @returns response
     * @throws SMSCollectionError 
    **/
    deleteMessage: async function(groupId, id) {
        try {
            const response = await ApiService.delete(`/sms-collections/${groupId}/templates/${id}`)
            
            return response.data
        } catch (error) {
            throw new SMSCollectionError(error.response.status, error.response.data.detail)
        }
    },
}

export { SMSCollectionService, SMSCollectionError }
